import {
    normalizeHostname,
    resolveCraneManagerHostname,
} from '~~/layers/base/utils/normalizeHostname'

/**
 * API base URL for client `$fetch` calls.
 *
 * - **Capacitor:** `runtimeConfig.public.apiBaseUrl` (`NUXT_PUBLIC_API_BASE_URL`), or designer
 *   base URL in production when API base is unset.
 * - **Web:** same-origin in dev (`undefined`); production uses designer base URL except on the
 *   Crane Manager host (path Access / optional hostname override), where same-origin is required
 *   so Better Auth cookies reach profile and staff APIs (TK-13632).
 *
 * `NUXT_PUBLIC_API_BASE_URL` must not drive web dev same-origin calls — only applies when
 * `NUXT_CAPACITOR_APP` is set (see `useApiBaseUrl` guard below).
 */
export const useApiBaseUrl = (): string | undefined => {
    const { public: pub } = useRuntimeConfig()
    const designerBase = !import.meta.env.DEV ? pub.designerBaseUrl?.trim() : undefined

    if (pub.NUXT_CAPACITOR_APP) {
        const apiBase = pub.apiBaseUrl?.trim()
        return apiBase || designerBase
    }

    // Staff host may differ from designerBaseUrl (prod: designer.app-crane.com vs app.crane.com).
    if (import.meta.client && !import.meta.env.DEV) {
        const craneManagerHost = resolveCraneManagerHostname(
            pub.craneManagerHostname,
            pub.designerBaseUrl
        )
        if (craneManagerHost && normalizeHostname(window.location.hostname) === craneManagerHost) {
            return undefined
        }
    }

    return designerBase
}
